import styled from '@emotion/styled'

export const SmallLabel = styled.label`
  font-size: 0.75em;
`
